import { permissionList } from "./constant";




const handleCheckViewManage = (permission, initialState) => {
    
    switch(permission) {
        
        case permissionList?.DASHBOARD_VIEW:
             initialState.isDashboradView = true;
             return initialState;
    
        case permissionList?.LEAD_VIEW: 
            initialState.isLeadView = true;
            return initialState;
            
        case permissionList?.INVOICE_VIEW: 
            initialState.isInvoiceView= true
            return initialState;
            
        case permissionList?.MERCHANT_VIEW: 
        
            initialState.isVendorView = true;
            return initialState;
            
        case permissionList?.PRODUCT_VIEW: 
            initialState.isProductView = true;
            return initialState;
            
        case permissionList?.ORDER_VIEW: 
            initialState.isOrderView =true
            return initialState; 
            
        case permissionList?.CONFIGURATION_VIEW: 
            initialState.isConfigurationView = true;
            return initialState;
            
        case permissionList?.CUSTOMER_VIEW: 
            initialState.isCustomerView = true;
            return initialState;
            
        case permissionList?.DASHBOARD_MANAGE: 
            initialState.isdashboardManage = true;
            initialState.isDashboradView = true;
            
            return initialState;
            
        case permissionList?.LEAD_MANAGE: 
            initialState.isLeadManage = true;
            initialState.isLeadView = true;
            
            return initialState;

        case permissionList?.ALL_LEAD_MANAGE: 
            initialState.isAllLeadManage = true;
            initialState.isLeadManage = true;
            initialState.isLeadView = true;
            
            return initialState;
            

        case permissionList?.INVOICE_MANAGE: 
            initialState.isInvoiceManage = true;
            initialState.isInvoiceView = true;
            
            return initialState;
            
        case permissionList?.ALL_INVOICE_MANAGE: 
            initialState.isAllInvoiceManage = true;
            initialState.isInvoiceManage = true;
            initialState.isInvoiceView = true;
            
            return initialState;
            
        case permissionList?.MERCHANT_MANAGE: 
            initialState.isVendorManage= true;
            initialState.isVendorView= true
            
            return initialState;

        case permissionList?.PRODUCT_MANAGE: 
            initialState.isProductManage= true;
            initialState.isProductView= true;
            
            return initialState;

        case permissionList?.ORDER_MANAGE: 
            initialState.isOrderManage= true;
            initialState.isOrderView= true;
            
            return initialState;
            
        case permissionList?.ALL_ORDER_MANAGE: 
            initialState.isAllOrderManage= true;
            initialState.isOrderManage= true;
            initialState.isOrderView= true;
            
            return initialState;

        case permissionList?.CONFIGURATION_MANAGE: 
            initialState.isConfigurationManage = true;
            initialState.isConfigurationView = true;
            
            return initialState;
            
        case permissionList?.CUSTOMER_MANAGE: 
            initialState.isCustomerManage= true;
            initialState.isCustomerView= true;
            
            return initialState;

        case permissionList?.NOTIFICATION_MANAGE:
            initialState.isNotificationManage = true;
            initialState.isNotificationView = true;

            return initialState;

        case permissionList.NOTIFICATION_VIEW:
            initialState.isNotificationView = true;

            return initialState;

        case permissionList.TEMPLATE_MANAGE:
            initialState.isTemplateManage = true;
            initialState.isTemplateView = true;

            return initialState;


        case permissionList.TEMPLATE_VIEW:
            initialState.isTemplateView = true;
         
            return initialState;

        case permissionList.AUDIT_MANAGE:
            initialState.isAuditManage = true;
            initialState.isAuditView = true;

            return initialState;


        case permissionList.AUDIT_VIEW:
            initialState.isAuditView = true;
         
            return initialState;

        case permissionList?.LEAD_TEAM_MANAGE: 
            initialState.isLeadTeamManage = true;
            initialState.isLeadManage = true;
            initialState.isLeadView = true;

            return initialState;

        case permissionList?.ORDER_TEAM_MANAGE: 
            initialState.isOrderTeamManage = true;
            initialState.isOrderManage = true;
            initialState.isOrderView = true;

            return initialState;

        case permissionList?.INVOICE_TEAM_MANAGE: 
            initialState.isInvoiceTeamManage = true;
            initialState.isLeadManage = true;
            initialState.isLeadView = true;

            return initialState;

    }   
}


export const handleCheckPermission = async(userpermissionData) => {

    var initialState = {
        isDashboradView: true,
        isdashboardManage: true,
        isCustomerView: true,
        isCustomerManage: true,
        isProductView: true,
        isProductManage: true,
        isOrderView: true,
        isOrderManage: true,
        isConfigurationView: true,
        isConfigurationManage: true,
        isInvoiceView: true,
        isInvoiceManage: true,
        isInvoiceTeamManage: true,
        isLeadView: true,
        isLeadManage: true,
        isAllLeadManage:true,
        isLeadTeamManage:true,
        isAllInvoiceManage:true,
        isAllOrderManage:true,
        isOrderTeamManage:true,
        isVendorView: true,
        isVendorManage: true,
        isTemplateManage: true,
        isTemplateView: true,
        isNotificationView: true,
        isNotificationManage: true,
        isAuditView: true,
        isAuditManage: true,
    }
    
    
    await userpermissionData?.map(item => {
         handleCheckViewManage(item?.authority, initialState);
    })

    return initialState;
    
} 


export const renderRoutesBasedOnPermission = () => {
    
}